"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fireAndForget = exports.formatAction = exports.formatPayload = exports.formatSavedSearches = exports.getPropertyId = exports.removeFalsies = exports.isFalsie = exports.getSessionId = void 0;
var uuid_1 = require("uuid");
var path_1 = __importDefault(require("ramda/src/path"));
var pathOr_1 = __importDefault(require("ramda/src/pathOr"));
var actionTypes_1 = __importStar(require("./actionTypes"));
function getSessionId() {
    var sId = window.sessionStorage.getItem('sessionId');
    if (sId) {
        return sId;
    }
    var guid = (0, uuid_1.v4)();
    window.sessionStorage.setItem('sessionId', guid);
    return guid;
}
exports.getSessionId = getSessionId;
function isFalsie(value) {
    switch (true) {
        case value === '-1' || value === -1:
        case value === null || !value:
        case Array.isArray(value) && !value.length:
            return true;
        default:
            return false;
    }
}
exports.isFalsie = isFalsie;
function removeFalsies(obj) {
    return Object.entries(obj).reduce(function (trued, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        if (!isFalsie(value)) {
            return __assign((_b = {}, _b[key] = value, _b), trued);
        }
        return trued;
    }, {});
}
exports.removeFalsies = removeFalsies;
function getPropertyId(payload, state) {
    if (payload === void 0) { payload = {}; }
    if (state === void 0) { state = {}; }
    return [
        (0, path_1.default)(['PropertyID'], payload),
        (0, path_1.default)(['tracking', 'propertyId'], payload),
        (0, path_1.default)(['Property', 'ExternalPropertyIDFormatted'], payload),
        (0, path_1.default)(['propertyDetail', 'property', 'ExternalPropertyIDFormatted'], state),
    ].find(function (id) { return Boolean(id); });
}
exports.getPropertyId = getPropertyId;
function formatSavedSearches(savedSearches) {
    return savedSearches.map(function (search) { return ({
        SearchContext: {
            Criteria: __assign(__assign({}, removeFalsies(search.SearchContext.Criteria)), { Tags: search.SearchContext.Criteria.Tags.filter(function (tag) { return tag !== '-1'; }) }),
        },
    }); });
}
exports.formatSavedSearches = formatSavedSearches;
function formatPayload(type, actionPayload) {
    if (type === (0, actionTypes_1.getSuccessType)(actionTypes_1.default.ACCOUNT_LOGIN)) {
        return {};
    }
    var payload = __assign({}, actionPayload);
    if ((0, path_1.default)(['Results', 'SearchContext', 'Criteria'], actionPayload)) {
        var _a = actionPayload.Results, SearchContext = _a.SearchContext, ListHeader = _a.ListHeader, SearchUrl = _a.SearchUrl, ShareUrl = _a.ShareUrl;
        payload = {
            BeginTime: actionPayload.BeginTime,
            Results: {
                SearchContext: {
                    Criteria: removeFalsies(SearchContext.Criteria),
                },
                ListHeader: ListHeader,
                SearchUrl: SearchUrl,
                ShareUrl: ShareUrl,
            },
        };
    }
    if (type === actionTypes_1.default.MAP_INFOBOX_SHOW) {
        payload = {
            id: actionPayload.Property.ExternalPropertyID,
        };
    }
    if (type === (0, actionTypes_1.getSuccessType)(actionTypes_1.default.PROFILE_GET_USER_INFO)) {
        payload = {
            profile: {
                user: actionPayload.Results.MemberProfile,
                savedProperties: actionPayload.Results.SavedProperties,
                savedSearches: formatSavedSearches(actionPayload.Results.SavedSearches),
            },
        };
    }
    if (type === actionTypes_1.default.SESSION_DATA_LOADED) {
        payload = {
            profile: {
                user: actionPayload.profile.user,
                savedProperties: actionPayload.profile.savedProperties.data,
                savedSearches: formatSavedSearches(actionPayload.profile.savedSearches),
            },
        };
    }
    if (actionPayload.agent) {
        payload = __assign(__assign({}, payload), { agent: {
                AgentName: actionPayload.agent.AgentName,
                ID: actionPayload.agent.ID,
            } });
    }
    if (actionPayload.fields) {
        payload = __assign(__assign({}, payload), { fields: Object.entries(actionPayload.fields).reduce(function (acc, _a) {
                var _b;
                var key = _a[0], val = _a[1];
                return (key === 'subscribe'
                    ? __assign(__assign({}, acc), { subscribe: val }) : __assign(__assign({}, acc), (_b = {}, _b[key] = {
                    value: val.value,
                }, _b)));
            }, {}) });
    }
    return payload;
}
exports.formatPayload = formatPayload;
function formatAction(state, _a) {
    var type = _a.type, actionPayload = _a.payload;
    var payload = actionPayload && removeFalsies(formatPayload(type, actionPayload));
    var pageType = (0, pathOr_1.default)('', ['routerMap', 'currentRoute', 'page'], state).replace('/', '');
    var propertyId = getPropertyId(payload, state);
    var searchList = payload && (0, path_1.default)(['Results', 'SearchContext', 'Criteria', 'SearchList'], payload);
    var searchLocation = Array.isArray(searchList) && searchList.map(function (location) { return ({
        locationId: location.Id,
        name: location.AutoCompleteText,
        categoryId: location.Category,
    }); });
    return {
        type: type,
        payload: payload,
        searchLocation: searchLocation,
        propertyId: propertyId,
        pageType: pageType,
    };
}
exports.formatAction = formatAction;
function fireAndForget(data) {
    fetch(process.env.TRACKING_API_URL, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .catch(function (e) { return console.error(e); });
}
exports.fireAndForget = fireAndForget;
